import { render, staticRenderFns } from "./newenterin.vue?vue&type=template&id=3e85a2d2&scoped=true&"
import script from "./newenterin.vue?vue&type=script&lang=js&"
export * from "./newenterin.vue?vue&type=script&lang=js&"
import style0 from "./newenterin.vue?vue&type=style&index=0&id=3e85a2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e85a2d2",
  null
  
)

export default component.exports